import React from 'react';
import { Modal, Form, Input, Select, Checkbox, Button } from 'antd';
import { RiCloseFill } from 'react-icons/ri';
import ApiService from '../../../../../network/ApiService';

const { Option } = Select;

const ManualRegistrationModal = ({ visible, onCancel }) => {
    const [form] = Form.useForm();
    const apiService = new ApiService();

    const generatePassword = (length = 6) => {
        const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        let password = "";
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            password += charset[randomIndex];
        }
        return password;
    };

    const initial_password = generatePassword();

    const handleCreate = async () => {
        try {
            const values = await form.validateFields();
            const payload = { ...values, initial_password };
            await apiService.post('registrations/register', payload);
            alert('Registration submitted!');
            form.resetFields();
            onCancel(); // Dismiss modal after successful submission
        } catch (errorInfo) {
            alert('Registration failed: ' + errorInfo.message);
        }
    };

    return (
        <Modal
            title={`Manuelle Registrierung – ${initial_password}`}
            width={600}
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Abbrechen
                </Button>,
                <Button key="submit" type="primary" onClick={handleCreate}>
                    Registrierung anlegen
                </Button>,
            ]}
            closeIcon={<RiCloseFill className="remix-icon text-color-black-100" size={24} />}
        >
            <Form form={form} layout="vertical" name="manualRegistrationForm">
                <div style={{ marginBottom: 24 }}>
                    <h3>Kontaktinformationen</h3>
                    <Form.Item
                        label="Vorname der primären Kontaktperson"
                        name={['primaryContact', 'first']}
                        rules={[{ required: true, message: 'Bitte Vornamen eingeben.' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Nachname der primären Kontaktperson"
                        name={['primaryContact', 'last']}
                        rules={[{ required: true, message: 'Bitte Nachnamen eingeben.' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Telefon der primären Kontaktperson"
                        name={['primaryContact', 'phone']}
                        rules={[{ required: true, message: 'Bitte Telefonnummer eingeben.' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="E-Mail der primären Kontaktperson"
                        name={['primaryContact', 'email']}
                        rules={[{ required: true, message: 'Bitte E-Mail-Adresse eingeben.' }]}
                    >
                        <Input type="email" />
                    </Form.Item>
                    <Form.Item
                        label="Vorname der sekundären Kontaktperson"
                        name={['secondaryContact', 'first']}
                        rules={[{ required: true, message: 'Bitte Vornamen eingeben.' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Nachname der sekundären Kontaktperson"
                        name={['secondaryContact', 'last']}
                        rules={[{ required: true, message: 'Bitte Nachnamen eingeben.' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Telefon der sekundären Kontaktperson"
                        name={['secondaryContact', 'phone']}
                        rules={[{ required: true, message: 'Bitte Telefonnummer eingeben.' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="E-Mail der sekundären Kontaktperson"
                        name={['secondaryContact', 'email']}
                        rules={[{ required: true, message: 'Bitte E-Mail-Adresse eingeben.' }]}
                    >
                        <Input type="email" />
                    </Form.Item>
                </div>

                <div style={{ marginBottom: 24 }}>
                    <h3>Registrierungsdetails</h3>
                    <Form.Item
                        label="Mannschaftsname"
                        name="teamName"
                        rules={[{ required: true, message: 'Bitte Mannschaftsnamen eingeben.' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Vereinsname"
                        name="verein"
                    >
                        <Input placeholder="Optional" />
                    </Form.Item>
                    <Form.Item
                        label="Bundesland"
                        name="bundesland"
                        rules={[{ required: true, message: 'Bitte Bundesland auswählen.' }]}
                    >
                        <Select placeholder="Bundesland auswählen">
                            <Option value="wien">Wien</Option>
                            <Option value="niederoesterreich">Niederösterreich</Option>
                            <Option value="oberoesterreich">Oberösterreich</Option>
                            <Option value="steiermark">Steiermark</Option>
                            <Option value="kaernten">Kärnten</Option>
                            <Option value="salzburg">Salzburg</Option>
                            <Option value="tirol">Tirol</Option>
                            <Option value="vorarlberg">Vorarlberg</Option>
                            <Option value="burgenland">Burgenland</Option>
                            <Option value="ausgetreten">Ausgetreten</Option>
                            <Option value="auszuwerten">Auszuwerten</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Vereinsart"
                        name="type"
                        rules={[{ required: true, message: 'Bitte Vereinsart auswählen.' }]}
                    >
                        <Select placeholder="Vereinsart auswählen">
                            <Option value="privat">Privat</Option>
                            <Option value="professional">Professional</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="acceptedAGB"
                        valuePropName="checked"
                        rules={[{ required: true, message: 'Die AGB müssen akzeptiert werden.' }]}
                    >
                        <Checkbox>AGB akzeptiert</Checkbox>
                    </Form.Item>
                    <Form.Item
                        label="Empfehlungscode"
                        name="referCode"
                        // No validation rules here, so it remains optional
                    >
                        <Input />
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    );
};

export default ManualRegistrationModal;
